import React, { Component } from 'react'
import FixedView from '../../../FixedView'
import SwitchInput from '../../../inputs/SwitchInput'
import TextInput from '../../../inputs/TextInput'
import Modal from '../../../Modal'
import { checkTranslation, imageAddress, translate } from '../../../../utils/useful'
import ButtonAnimated from '../../../buttons/ButtonAnimated'





export default class ManageGroup extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        show: false,
        groupName: '',
        description: '',


        Members: [
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
            { img: "/assets/icons/Group 237788.svg", name: "Sara Mohseni", state: "{{lang}}messenger.Online", role: "{{lang}}messenger.Owner" },
        ],

        option: [
            { icon: "/assets/icons/manage-gray.svg", title: "{{lang}}messenger.Manage Group", color: "#444", key: "manage" },
            // { icon: "/assets/icons/leave-red.svg", title: "Leave Group", color: "#E61515", key: "leave" },
        ],

        manage: [
            { icon: "/assets/icons/messenger/group-type-blue.svg", name: "{{lang}}messenger.Group Type", state: "{{lang}}messenger.Private", key: "grouptype" },
            // { icon: "/assets/icons/messenger/chat.svg", name: "{{lang}}messenger.Chat history for new members", state: "Visible", key: "chatsetting" },
            { icon: "/assets/icons/messenger/topic-blue.svg", name: "{{lang}}messenger.Topics", state: "", key: "topic" },
            // { icon: "/assets/icons/messenger/like.svg", name: "{{lang}}messenger.Reaction", state: "All", key:"grouptype" },
            // { icon: "/assets/icons/messenger/key.svg", name: "{{lang}}messenger.Permissions", state: "8/8", key: "permission" },
            // { icon: "/assets/icons/messenger/link.svg", name: "{{lang}}messenger.Invite links", state: "1", key:"grouptype" },
            { icon: "/assets/icons/messenger/admin-blue.svg", name: "{{lang}}messenger.Adminestators", state: "1", key: "adminestators" },
            { icon: "/assets/icons/messenger/members.svg", name: "{{lang}}messenger.Members", state: "4", key: "members" },
            // { icon: "/assets/icons/messenger/bolt.svg", name: "{{lang}}messenger.Recent actions", state: "", key:"grouptype" },
        ]
    }

    componentDidMount = () => {
        // { console.log('this.propsaaaa', this.props.messenger?.image) }
        this.setState({ groupName: this.props.messenger.name, description: this.props.messenger?.description })
        let manage = this.state.manage
        manage.forEach((item) => {
            if (item.key == 'members') {
                item.state = this.props.messenger.users.length
            }
        })
        this.setState({ manage })
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }

    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    createGroup = () => {
        let hubs = this.form.getForm()
        if (this.state.groupName && hubs.hubs.length != 0) {
            let data = {}
            data.hubs = hubs.hubs
            data.groupName = this.state.groupName
            this.props.createGroup(data)
        }
    }

    updateGroup = () => {
        if (this.props.updateGroup) {
            let data = { name: this.state.groupName, description: this.state.description }
            this.props.updateGroup(data, this.props.messenger._id)
        }
    }

    render() {
        return (
            <div className='h-100 w-100 scroll-no-scrollbar'>
                <div className=' pb-2' style={{ borderBottom: "1px solid #eee" }}>
                    <div className='px-2 flexc' style={{ height: '60px', borderBottom: "1px solid #eee" }}>
                        <div className='w-100 flexcb'>
                            <div className='flexcb' style={{}}>
                                <button className='flexc' onClick={() => this.props.changeStage("info")}>
                                    <img width={20} src='/assets/icons/angle-right-black.svg' className='rtl-button' style={{ transform: 'rotate(180deg)' }} />
                                    <p className='text-bold text-small px-1' style={{}}>{translate('messenger.Manage Group')}</p>
                                </button>
                            </div>
                            <div className='flexc'>
                                <div className="px-1">
                                    <ButtonAnimated
                                        onClick={() => this.props.changeStage('info')}
                                        title={translate('messenger.Discard')}
                                        bg={'linear-gradient(to right, #eee, #eee)'}
                                        textColor={'#777'}
                                        width={'100%'}
                                    />
                                </div>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => { this.updateGroup() }}
                                    title={translate('messenger.Save')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={'#fff'}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                    width={'100%'}
                                />
                            </div>
                            {/* <div className='flexc blur-bg py-2 w-100' style={{ position: "fixed", bottom: 0, zIndex: 10 }}>
                        <button className='gray-btn w-100 mx-2 py-2 br-5' onClick={() => this.props.changeStage('info')}>
                            <p className='main-c5'>{translate('messenger.Discard')}</p>
                        </button>
                        <button className='save-btn2 w-100 mx-2 py-2 br-5'>
                            <p>{translate('messenger.Save')}</p>
                        </button>
                    </div> */}
                        </div>
                    </div>
                    <div className='flexcb px-2 py-2 w-100'>
                        <div className=''>
                            {this.props.messenger?.image && Array.isArray(this.props.messenger?.image) && this.props.messenger?.image[0] ?
                                <div className='flexcc br-100' style={{ width: '56px', height: '56px', background: '#0085ff' }}>
                                    <img src={imageAddress(this.props.messenger?.image[0], 'group', 'small')} className='br-100' style={{ width: '56px', height: '56px', }} />
                                    {/* <p className='font-size-14 weight-700' style={{ color: '#fff' }}>{this.state.groupName.charAt(0)}</p> */}
                                </div>
                                :
                                <div className='flexcc br-100' style={{ width: '56px', height: '56px', background: '#0085ff' }}>
                                    <p className='font-size-14 weight-700' style={{ color: '#fff' }}>{this.state.groupName.charAt(0)}</p>
                                </div>
                            }
                        </div>
                        <div className='mld-4 w-100'>
                            <div className='flexcc w-100 br-10 messenger-input px-2 py-2'>
                                <TextInput data={this.state.groupName} changeValue={this.changeValue} header={{ key: 'groupName', information: { rows: 1, placeholder: '{{lang}}messenger.Group Name' }, }} />
                            </div>
                        </div>
                    </div>
                    <div className='w-100 px-2 py-2'>
                        <div className='flexcc w-100 br-10 messenger-input px-2 py-2'>
                            <TextInput data={this.state.description} changeValue={this.changeValue} header={{ key: 'description', information: { rows: 1, placeholder: '{{lang}}messenger.Description' }, }} />
                        </div>
                    </div>
                </div>
                <div className='mx-2 '>
                    {this.state.manage.map((prop, index) => {
                        return (
                            <button className='flexcb my-2 py-2 w-100 prd-3 pld-2 hover-gray br-10' onClick={() => this.props.changeStage(prop.key)}>
                                <div className='flexc'>
                                    <img className='mrd-3' width={22} src={prop.icon} />
                                    <p className='main-c5 text-start'>{checkTranslation(prop.name)}</p>
                                </div>
                                <p className='bb-gray' style={{ color: "#0085ff" }}>{checkTranslation(prop.state)}</p>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    }
}
